import { Http } from "../../utils/types";
import { Format } from "../../utils/types/generals";
import { formatCatalog } from "./format";
import { CatalogList } from "./response";

export const serviceShared = (client: Http) => ({
    catalogList: async (): Format<CatalogList> => {
        const response = await client.get<CatalogList>('catalog')
        return formatCatalog({ response })
    }
})